import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class TrosakDokumentView extends BaseEntity{

    constructor(){
        super();
    }
    PodVrstaDokumentaStavka: string;
    Komitent: string;
    BrojDokumenta: string;
    Datum: NgbDate;
    Ukupno: number;
    KomitentMesto: string;    

    Deserialize(input: any){
        this.ID = input.ID;
        this.PodVrstaDokumentaStavka = input.PodVrstaDokumentaStavka;
        this.Komitent = input.Komitent;
        this.BrojDokumenta = input.BrojDokumenta;
        this.Datum = input.Datum;     
        this.Ukupno = input.Ukupno; 
        this.KomitentMesto = input.KomitentMesto;
        return this;
    }

    Serialize(input: TrosakDokumentView){
        return input;
    }

    GetInstance(){
        return this;
    }
}